import { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX, SkipForward, Music2, X } from "lucide-react";
import { api } from "@/lib/api";
import { mediaSrc } from "@/components/HeroVideo";

const SPOTIFY = [
  { label: "Sean Ardoin — Zydeco Trailrides & Southern Soul", src: "https://open.spotify.com/embed/album/42GqcG7tMgGcZ2qVjqIUze?theme=0" },
  { label: "Chris Ardoin", src: "https://open.spotify.com/embed/artist/0ejKajmLi2MClrte6SV5BC?theme=0" },
  { label: "Zydeco / Trail Ride Music", src: "https://open.spotify.com/embed/playlist/4wLrGylYDdmIDDbGTFwjnW?theme=0" },
];

export const MusicPlayer = () => {
  const [tracks, setTracks] = useState(null);
  const [idx, setIdx] = useState(0);
  const [playing, setPlaying] = useState(false);
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState(0);
  const ref = useRef(null);

  useEffect(() => { api.get("/admin/tracks/public").then((r) => setTracks(r.data)).catch(() => setTracks([])); }, []);

  const custom = tracks && tracks.length > 0;
  const track = custom ? tracks[idx] : null;

  const play = async (a) => { try { a.volume = 0.35; await a.play(); setPlaying(true); } catch { setPlaying(false); } };
  const toggle = () => {
    if (!custom) return setOpen((o) => !o);
    const a = ref.current;
    if (playing) { a.pause(); setPlaying(false); } else play(a);
  };
  const next = () => { const n = (idx + 1) % tracks.length; setIdx(n); setTimeout(() => { ref.current?.load(); play(ref.current); }, 50); };

  return (
    <>
      {track && <audio ref={ref} src={mediaSrc(track.url)} preload="none" onEnded={next} data-testid="music-audio" />}
      {open && !custom && (
        <div className="fixed bottom-24 right-5 z-50 w-[340px] max-w-[92vw] rounded-2xl border border-white/30 bg-black p-3  backdrop-blur" data-testid="vibe-drawer">
          <div className="flex items-center justify-between px-1">
            <span className="font-mono-label text-[10px] uppercase tracking-widest text-white">Trail Ride Vibe · Official Spotify</span>
            <button onClick={() => setOpen(false)} data-testid="vibe-close" className="text-neutral-400 hover:text-white"><X className="h-4 w-4" /></button>
          </div>
          <div className="mt-2 flex gap-1">
            {SPOTIFY.map((s, i) => (
              <button key={s.label} onClick={() => setTab(i)} data-testid={`vibe-tab-${i}`} className={`flex-1 truncate rounded-full px-2 py-1 font-mono-label text-[9px] uppercase ${tab === i ? "bg-white text-black" : "text-neutral-400 hover:text-white"}`}>{s.label.split(" — ")[0]}</button>
            ))}
          </div>
          <iframe key={tab} title={SPOTIFY[tab].label} src={SPOTIFY[tab].src} width="100%" height="352" frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" className="mt-2 rounded-xl" data-testid="vibe-spotify" />
          <a href={SPOTIFY[tab].src.replace("/embed", "").split("?")[0]} target="_blank" rel="noreferrer" data-testid="vibe-open-spotify" className="mt-2 block text-center font-mono-label text-[9px] uppercase tracking-widest text-neutral-500 hover:text-white">Open in Spotify ↗</a>
        </div>
      )}
      <div className="fixed bottom-5 right-5 z-50 flex items-center gap-1 rounded-full border border-white/30 bg-black p-1.5 pl-2 text-white  backdrop-blur" data-testid="music-player">
        <button onClick={toggle} data-testid="music-toggle-btn" aria-label="Toggle background music" className="flex items-center gap-2 rounded-full px-3 py-2 transition-transform hover:scale-105 active:scale-95">
          {playing || open ? <Volume2 className="h-5 w-5 animate-pulse" /> : <VolumeX className="h-5 w-5" />}
          <span className="hidden flex-col items-start leading-tight sm:flex">
            <span className="font-mono-label text-[10px] uppercase tracking-widest" data-testid="music-status">{custom ? (playing ? "Now Playing" : "Play The Vibe") : open ? "Trail Ride Vibe" : "Play The Vibe"}</span>
            <span className="max-w-[200px] truncate text-[11px] text-neutral-300" data-testid="music-track">{track ? `${track.title} · ${track.artist}` : "Zydeco · Southern Soul"}</span>
          </span>
          <Music2 className="h-4 w-4 sm:hidden" />
        </button>
        {custom && tracks.length > 1 && <button onClick={next} data-testid="music-next-btn" aria-label="Next track" className="rounded-full p-2 hover:bg-white/10"><SkipForward className="h-4 w-4" /></button>}
      </div>
    </>
  );
};
